<form [formGroup]="form()" class="flex flex-col gap-4">
    <!-- Referral name -->
    <sh-input-text
        data-testid="details-refer-out-dialog-input-referral-name"
        formControlName="name"
        [label]="'nam.parallel-referral-dialog.form.name' | translate"
        [error]="form().controls.name.touched && form().controls.name.invalid"
        [attr.error-message]="
            form().controls.name.hasError('required') && form().controls.name.touched
                ? ('nam.parallel-referral-dialog.form.name-required' | translate)
                : null
        "
        mandatory
    ></sh-input-text>

    @if (isExternal()) {
        <sh-input-text
            data-testid="details-refer-out-dialog-input-external-email"
            formControlName="referredOutEmail"
            [label]="'nam.external-referral-dialog.form.external-assignee-email' | translate"
            [error]="
                form().controls.referredOutEmail.invalid &&
                (form().controls.referredOutEmail.touched ||
                    form().controls.referredOutEmail.hasError('duplicateEmail'))
            "
            [attr.error-message]="
                form().controls.referredOutEmail.hasError('required') && form().controls.referredOutEmail.touched
                    ? ('nam.external-referral-dialog.form.external-assignee-email-required' | translate)
                    : form().controls.referredOutEmail.hasError('email') && form().controls.referredOutEmail.touched
                      ? ('nam.external-referral-dialog.form.external-assignee-email-invalid' | translate)
                      : form().controls.referredOutEmail.hasError('duplicateEmail')
                        ? ('nam.external-referral-dialog.form.external-assignee-email-duplicate' | translate)
                        : null
            "
            mandatory
        ></sh-input-text>
    } @else {
        <sh-assignee-picker
            data-testid="details-refer-out-dialog-input-assignee"
            formControlName="assignee"
            [label]="'common.general.assignee' | translate"
            [teamIndicator]="'nam.parallel-referral-dialog.form.team-indicator' | translate"
            [placeholder]="'common.general.assignee' | translate"
            [roles]="roles()"
            [businessService]="businessService()"
            [excludeIds]="excludeIds()"
            [error]="form().controls.assignee.touched && form().controls.assignee.invalid"
            [mandatory]="true"
            optionTestId="details-refer-out-dialog-option-assignee"
        ></sh-assignee-picker>
        @if (form().controls.assignee.touched && form().controls.assignee.hasError('required')) {
            <span class="text-xs text-shui-feedback-red -mt-3">
                {{ 'nam.parallel-referral-dialog.form.assignee-required' | translate }}
            </span>
        }
    }

    <!-- Internal message toggle -->
    @if (canMarkCommentAsInternal()) {
        <sh-checkbox
            formControlName="markAsInternal"
            [label]="'common.request-detail.comments.internal-message' | translate"
        ></sh-checkbox>
    }

    <!-- Description / comment -->
    <sh-input-text
        data-testid="details-refer-out-dialog-textarea-description"
        formControlName="description"
        textarea
        [label]="
            (isReferredOutAfterSubmission()
                ? isExternal()
                    ? 'nam.external-referral-dialog.form.task-description-optional'
                    : 'nam.parallel-referral-dialog.form.task-description-optional'
                : isExternal()
                  ? 'nam.external-referral-dialog.form.task-description'
                  : 'nam.parallel-referral-dialog.form.task-description'
            ) | translate
        "
        [error]="form().controls.description.touched && form().controls.description.invalid"
        [attr.error-message]="
            !isReferredOutAfterSubmission() &&
            (form().controls.description.hasError('required') || form().controls.description.hasError('pattern')) &&
            form().controls.description.touched
                ? ('nam.parallel-referral-dialog.form.task-description-required' | translate)
                : null
        "
        [mandatory]="!isReferredOutAfterSubmission()"
        class="w-full"
    ></sh-input-text>

    <!-- File upload -->
    <sh-file-input formControlName="attachments" [multiple]="true" class="w-full"></sh-file-input>
</form>
